import {CaretDownOutlined, CaretUpOutlined} from '@ant-design/icons';
import {TreeSelect} from 'antd';
import produce from "immer";
import React, {useState} from 'react';
import ToolTip, {
    AND as _AND,
    AND_AFTER_INDEX,
    AND_BEFORE_INDEX,
    AND_INDEX,
    DEFINE_RELATIONSHIP_BETWEEN_CRITERIA,
    DEFINE_RELATIONSHIP_BETWEEN_EVENTS,
    NOT_BETWEEN_CRITERIA,
    NOT_BETWEEN_EVENTS,
    NOT_AFTER_INDEX,
    NOT_BEFORE_INDEX,
    NOT_INDEX,
    OR as _OR
} from '../components/common/ToolTip';
import {TimeGreen} from "./CohortBuilder/TimeBetweenEvents/icons/TimeGreen";
import styles from './Operator.module.scss';

const { SHOW_PARENT, } = TreeSelect;

export const O_AND = 'and'
export const O_AND_BEFORE = 'and-before'
export const O_AND_INDEX = 'and-index'
export const O_AND_AFTER = 'and-after'
export const O_OR = 'or'
export const O_NOT = 'not'
export const O_NOT_BEFORE = 'not-before'
export const O_NOT_INDEX = 'not-index'
export const O_NOT_AFTER = 'not-after'

const treeDataWithChildren = (isBetweenEvents) => {
    const AND = {
        title: <span className={styles.option}>AND<ToolTip content={_AND}/><TimeGreen size={3.7}/></span>,
        value: O_AND,
        key: O_AND,
        children: [
            {
                title: <span className={styles.option}>Before Index<ToolTip content={AND_BEFORE_INDEX}/><TimeGreen
                    size={3.7}/></span>,
                value: O_AND_BEFORE,
                key: O_AND_BEFORE,
            },
            {
                title: <span className={styles.option}>Index<ToolTip content={AND_INDEX}/><TimeGreen size={3.7}/></span>,
                value: O_AND_INDEX,
                key: O_AND_INDEX,
            },
            {
                title: <span className={styles.option}>After Index<ToolTip content={AND_AFTER_INDEX}/><TimeGreen
                    size={3.7}/></span>,
                value: O_AND_AFTER,
                key: O_AND_AFTER,
            },
        ],
    }
    const OR = {
        title: <>OR<ToolTip content={_OR}/></>,
        value: O_OR,
        key: O_OR,
        children: [],
    }

    const NOT_TITLE = isBetweenEvents ?
        <>NOT<ToolTip content={NOT_BETWEEN_EVENTS}/></> :
        <>NOT<ToolTip content={NOT_BETWEEN_CRITERIA}/></>

    const NOT = {
        title: NOT_TITLE,
        value: O_NOT,
        key: O_NOT,
        children: [
            {
                title: <>Before Index<ToolTip content={NOT_BEFORE_INDEX}/></>,
                value: O_NOT_BEFORE,
                key: O_NOT_BEFORE,
            },
            {
                title: <>Index<ToolTip content={NOT_INDEX}/></>,
                value: O_NOT_INDEX,
                key: O_NOT_INDEX,
            },
            {
                title: <>After Index<ToolTip content={NOT_AFTER_INDEX}/></>,
                value: O_NOT_AFTER,
                key: O_NOT_AFTER,
            },
        ],
    }

    return [AND, OR, NOT];

}

const treeDataWithoutChildren = (isBetweenEvents) => {
    return produce(treeDataWithChildren(isBetweenEvents), draftState => {
        return draftState
            .filter(i => i.value !== O_OR)
            .map(i => {
                return {
                    title: i.title,
                    value: i.value,
                    key: i.key,
                }
            })
    })
}

const Operator = ({ currentValue, showIcons, showChildren, onOperatorChanged, isBetweenEvents }) => {
    const [value, setValue] = useState(currentValue)

    const choices = () => {
        if (showChildren) {
            return treeDataWithChildren(isBetweenEvents)
        } else {
            return treeDataWithoutChildren(isBetweenEvents)
        }
    }

    const handleOptionWithChildren = (type, newValue, extra) => {
        if (value.filter(i => !i.startsWith(type)).length >= 1) {
            setValue([extra.triggerValue])
            onOperatorChanged()([extra.triggerValue])
        } else {
            setValue(newValue)
            onOperatorChanged()(newValue)
        }
    }

    const onChange = (newValue, label, extra) => {
        // a value must be check at all times
        if (newValue.length === 0) {
            return
        }
        if (extra.triggerValue.startsWith(O_AND)) {
            handleOptionWithChildren(O_AND, newValue, extra)
        }
        if (extra.triggerValue.startsWith(O_OR)) {
            setValue([extra.triggerValue])
            onOperatorChanged()([extra.triggerValue])
        }
        if (extra.triggerValue.startsWith(O_NOT)) {
            handleOptionWithChildren(O_NOT, newValue, extra)
        }
    }

    const width = showChildren ? 250 : 110

    return <>
        <div className="operator">
            {showIcons ? <CaretUpOutlined style={{ fontSize: '2em' }} /> : ""}
            <TreeSelect
                treeData={choices()}
                value={value}
                onChange={onChange}
                treeCheckable={true}
                showCheckedStrategy={SHOW_PARENT}
                placeholder='Please select'
                style={{ 'width': width }}
                treeDefaultExpandAll={true}
                data-testid="operator-tree"
            />
            <ToolTip content={isBetweenEvents ? DEFINE_RELATIONSHIP_BETWEEN_EVENTS : DEFINE_RELATIONSHIP_BETWEEN_CRITERIA}/>
            {showIcons ? <CaretDownOutlined style={{ fontSize: '2em' }} /> : ""}
        </div>
    </>
}
export default Operator